import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Document = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M21,24H3c-0.552,0-1-0.447-1-1V1c0-0.552,0.448-1,1-1h18c0.552,0,1,0.448,1,1v22\n\t\t    C22,23.553,21.552,24,21,24z M4,22h16V2H4V22z" }),
    React.createElement("path", { d: "M17,8H7C6.448,8,6,7.552,6,7s0.448-1,1-1h10c0.552,0,1,0.448,1,1S17.552,8,17,8z" }),
    React.createElement("path", { d: "M17,13H7c-0.552,0-1-0.447-1-1c0-0.552,0.448-1,1-1h10c0.552,0,1,0.448,1,1\n\t\t    C18,12.553,17.552,13,17,13z" }),
    React.createElement("path", { d: "M11,18H7c-0.552,0-1-0.447-1-1s0.448-1,1-1h4c0.552,0,1,0.447,1,1S11.552,18,11,18z" })), 'Document');
export default Document;
